// Any config specific to KUWAIT?

export default {
  code: 'KWT',
  countryName: 'Kuwait',
  googleSiteVerificationCode: [
    'MDEoB36-x_HiEDC0hqR56VTvlyN-sAnetUtIfp_7e3A',
    '_viv4eF2_WQyPt0KHvu7AIIxNuRdov0_wdQi-xf6oS0'
  ],
  countryDomain: 'https://www.carrefourkuwait.com',
  helplineNumber: '16061',
  latitude: 29.274947852071165,
  longitude: 47.99940805334711,
  countryFlagIcon: 'KW_02ec133b23.png',
  defaultAreaCode: 'Zahra - Hawally',
  features: {
    languageChange: true,
    now: false,
    share: false,
    isLocationCXEnable: true,
    isNewAddress: true,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: 'aff4cb88-5d5f-42ad-922a-511be385c518'
  }
}
